module.exports = __webpack_public_path__ + "h5/img/staff.69214abc.jpg";